const apiURL = "https://goapi.bigblueocean.dev"
const siteURL = "https://goportal.bigblueocean.dev"


export {  
  apiURL,
  siteURL,
  };

export default {
  apiURL,
  siteURL
  
};
